import { Component, Inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { GridModalData } from '@app/core/components/grid/modals/grid-modal.service';
import { LogisticService, StockLocation } from '@app/services/logistic.service';
import { PurchHeadReceiveSimplifiedGet, PurchHeadService } from '@app/services/purch-head.service';
import { PurchLineItem } from '@app/views/components/purch-head/purch-head-purch-lines/purch-head-purch-lines.component';
import { ModalService } from '@app/core/services/modal.service';

@GridModalComponent('PurchHeadReceiveSimplifiedDialogTs')
@Component({
    selector: 'tt-purch-head-receive-simplified',
    templateUrl: './purch-head-receive-simplified.component.html',
    styleUrls: ['./purch-head-receive-simplified.component.css'],
})
export class PurchHeadReceiveSimplifiedComponent {
    public get?: PurchHeadReceiveSimplifiedGet;

    public stocklocations: StockLocation[] = [];

    public creating = false;

    constructor(
        private purchhead: PurchHeadService,
        private logistic: LogisticService,
        private modal: ModalService,
        public dialogRef: MatDialogRef<PurchHeadReceiveSimplifiedComponent>,
        @Inject(MAT_DIALOG_DATA) private data: GridModalData<PurchLineItem>,
    ) {
        console.log(data);
        this.init();
    }

    public async create() {
        if (!this.get) return;

        try {
            this.creating = true;

            const { errorcode, errormessage } = await this.purchhead.createPurchHeadReceiveSimplified({ ...this.get, records: this.data.selectedRows });

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                this.dialogRef.close();
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.creating = false;
        }
    }

    private async loadGet() {
        let parameters: any = {};

        if (!!this.data.loadData?.parameters) {
            if (typeof this.data.loadData.parameters === 'object') {
                parameters = this.data.loadData.parameters;
            }

            if (this.data.loadData.parameters instanceof Function) {
                parameters = await this.data.loadData.parameters();
            }
        }

        this.get = await this.purchhead.getPurchHeadReceiveSimplified(parameters);
    }

    private async loadStocklocations() {
        if (!!this.get) {
            this.stocklocations = await this.logistic.getStockLocations(this.get.stockplace_id);
        }
    }

    private async init() {
        await this.loadGet();
        this.loadStocklocations();
    }
}
